import React, { useState, useEffect } from "react";
import { WidgetTresholdLimitMonitor } from "../widgets/WidgetTresholdLimitMonitor";

import { FILTER_COUNTRY_SELECTION } from "../../../constants";

export const Tresholds = (props) => {
  const [countryFilter, setCountryFilter] = useState('all');

  useEffect(() => {
    // on change we request new prices as well
    // console.log(countryFilter);
  }, [countryFilter]);

  return (
    <>
      <div className="Dashboard__content__top-row">
        <h2> Treshold limit Monitor </h2>

        <ul className="Dashboard__content__top-row__selectors">
          <li>
            <select className="countr-selector" onChange={(e) => setCountryFilter(e.target.value)}>
              {FILTER_COUNTRY_SELECTION.map((item, i) => {
                return (
                  <option
                    value={item.value}
                    key={i}
                  >
                    {item.label}
                  </option>
                );
              })}
            </select>
          </li>
        </ul>
      </div>
          
      <WidgetTresholdLimitMonitor globalCurrency={props.globalCurrency} hideTitle={true} countryFilter={countryFilter} />
    </>
  );
};
